import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash"

export class PlanningDepotsSelectionTableCtrl implements IController {
  depots: any;
  selectedIds: any;
  onSelect: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.selectedIds) {
      this.selectedIds = [];
    }
  }

  isSelectedDepot(depot) {
    return _.indexOf(this.selectedIds, depot.syncId) !== -1;
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningDepotsSelectionTable', {
    bindings: {
      depots: '<',
      selectedIds: '<?',
      onSelect: '&'
    },
    template: require("./planning-depots-selection-table.html").default,
    controller: PlanningDepotsSelectionTableCtrl
  });
